import React from 'react';

import { useGetCarts } from 'entities/cart';
import { useRouteChangeHandler } from 'shared/hooks';

import { CartIcon, MyPageIcon, ShortlistIcon } from './Icons';
import { NotificationIcon } from './NotificationIcon';

const ServiceIcons = () => {
  const { handleRouteChange } = useRouteChangeHandler();
  const { data: cartsData } = useGetCarts();
  const cartCount = cartsData?.cartInfos?.length ?? 0;

  return (
    <div className="flex items-center gap-1">
      <button
        className="flex h-11 w-11 items-center justify-center rounded-full hover:bg-[#F6F6F6]"
        aria-label="notifications"
      >
        <NotificationIcon />
      </button>

      <button
        className="hidden h-11 w-11 items-center justify-center rounded-full hover:bg-[#F6F6F6] md:flex"
        aria-label="shortlist"
        onClick={() => {
          window.dataLayer?.push({
            event: 'click_menu',
            menu: 'shortlist',
            section: 'Header',
          });
          handleRouteChange('/shortlist');
        }}
      >
        <ShortlistIcon />
      </button>

      <button
        className="relative flex h-11 w-11 items-center justify-center rounded-full hover:bg-[#F6F6F6]"
        aria-label="cart"
        onClick={() => {
          window.dataLayer?.push({
            event: 'click_menu',
            menu: 'cart',
            section: 'Header',
          });
          handleRouteChange('/carts');
        }}
      >
        <CartIcon />
        {cartCount > 0 && (
          <span className="absolute right-1.5 top-1.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-primary px-1 text-[10px] font-semibold leading-none text-white">
            {cartCount > 9 ? '9+' : cartCount}
          </span>
        )}
      </button>

      <button
        className="hidden h-11 w-11 items-center justify-center rounded-full hover:bg-[#F6F6F6] md:flex"
        aria-label="profile"
        onClick={() => {
          window.dataLayer?.push({
            event: 'click_menu',
            menu: 'profile',
            section: 'Header',
          });
          handleRouteChange('/my/notifications');
        }}
      >
        <MyPageIcon />
      </button>
    </div>
  );
};

export default ServiceIcons;
